import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import FormPrompt from "../DailogBoxes/formprompt";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import AddVendor from "./addvendor";
import { setvendor } from "../../actions/setvendoraction";
import { searchTextRegex } from "../../constant/regex";
import { isVendorRole, getVendorId } from "../../utils/rbac";

import "./vendorlist.css";

const VendorList = (props) => {
  const vendorLocked = isVendorRole();
  const lockedVendorId = vendorLocked ? getVendorId() : null;
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [limit, setLimit] = useState(10);
  const [isLoadMoreData, setIsLoadMoreData] = useState(false);
  const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [totalNumOfVendor, setTotalNumOfVendor] = useState(null);
  const [noMoreDataText, setNoMoreDataText] = useState("");
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [VendorList, setVendorList] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchDataShow, setIsSearchDataShow] = useState(false);
  const [selectedVendorName, setSelectedVendorName] = useState("");
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [SalonTypeList, setSalonTypeList] = useState([]);
  const [openDocumentDialog, setOpenDocumentDialog] = useState(false);
  const [selectedVendorDocs, setSelectedVendorDocs] = useState(null);
  const [isDocsVerified, setIsDocsVerified] = useState(false);
  const [isTogglingStatus, setIsTogglingStatus] = useState(false);
  const [selectedVendorIdd, setSelectedVendorIdd] = useState("");
  const [isDocUpdating, setIsDocUpdating] = useState(false);


  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      onSetTotalNumOfVendor();
      onFetchData(limit);
      onFetchSalonType();
    }
    return () => {
      isSubscribed = false;
    };
  }, []);
  const showMore = () => {
    if (limit <= totalNumOfVendor) {
      const limitNew = limit + 10;
      setLimit(limitNew);
      onFetchData(limitNew);
    } else {
      setNoMoreDataText("No MoreVendors");
    }
  };
  const onSetTotalNumOfVendor = async () => {
    setIsLoading(true);
    const res = await Service.getTotalNumOfPerson("vendors");
    if (res === "error") {
      console.log("error");

      setIsLoading(false);
    } else {
      setTotalNumOfVendor(res);
      setIsLoading(false);
    }
  };

  const onFetchData = async (limit) => {
  setIsLoadMoreData(true);

  const fetchedDataList = vendorLocked
    ? (await Service.getAllData("vendors")).filter((v) => v.uid === lockedVendorId)
    : await Service.getData("vendors", limit);

  if (fetchedDataList.length !== 0) {
    setVendorList(fetchedDataList); // ✅ NO OVERRIDES
  } else {
    setVendorList([]);
  }
  
  setIsLoadMoreData(false);
  setIsLoading(false);
};

  const onFetchSalonType = async () => {
    setIsLoadMoreData(true);

    const fetchedSalonDataList = await Service.getData("category");

    if (fetchedSalonDataList.length !== 0) {
      setSalonTypeList(fetchedSalonDataList);
      setIsLoadMoreData(false);
      setIsLoading(false);
    } else {
      setSalonTypeList(fetchedSalonDataList);
      setIsLoadMoreData(false);
      setIsLoading(false);
    }
  };
  const handleOnDelete = (VendorName, id) => {
    setSelectedVendorName(VendorName);
    setSelectedVendorId(id);
    setOpenConfirmDailog(true);
  };
  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("vendors", selectedVendorId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      window.location.reload(false);
    } else {
      setIsDeleting(false);
      handleErrorDailog();
    }
  };
  const handleSearch = async () => {
    if (searchText === "" || null) {
      window.location.reload(false);
    } else {
      setIsSearching(true);
      setIsSearchDataShow(true);

      const searchTextLower = searchText.toLowerCase().replace(searchTextRegex, "");

      const resultVendorList = await Service.getSearchRes(
        "vendors",
        searchTextLower
      );
      if (resultVendorList === "error") {
        setIsSearching(true);
        setOpenErrorDailog(true);
      } else {
        setIsSearching(false);
        setVendorList(resultVendorList);
      }
    }
  };

  const handleSuccessDailog = () => {
    setOpenFormDailog(false);
    setOpenAlertDailog(true);
  };
  const handleErrorDailog = () => {
    setOpenFormDailog(false);
    setOpenConfirmDailog(false);
    setOpenErrorDailog(true);
  };
  const closeFormDailog = () => {
    setOpenFormDailog(false);
  };
  const closeAlertDailog = () => {
    setOpenAlertDailog(false);
    window.location.reload(false);
  };
  const closeErrorDailog = () => {
    setOpenErrorDailog(false);
  };
  const closeConfirmDailog = () => {
    setOpenConfirmDailog(false);
  };
  const setCloseBtnAppear = () => {
    setIsCloseBtnAppear(false);
  };

  const toggleVendorStatus = async (vendorId, currentStatus) => {
    setIsTogglingStatus(true);
    const newStatus = !currentStatus;
    
    const res = await Service.updateData(
      { active: newStatus },
      "vendors",
      vendorId
    );

    if (res === "success") {
      setIsTogglingStatus(false);
      onFetchData(limit); // Refresh the list
    } else {
      setIsTogglingStatus(false);
      handleErrorDailog();
    }
  };

  /* ✅ ADD THIS FUNCTION HERE */
 const updateDocumentStatus = async (status) => {
  if (!selectedVendorIdd) return;

  setIsDocUpdating(true);

  const res = await Service.updateData(
    {
      documentVerification: status,
      active: status,
    },
    "vendors",
    selectedVendorIdd
  );

  if (res === "success") {
    setIsDocUpdating(false);
    setOpenDocumentDialog(false);
    onFetchData(limit); // ✅ refresh list WITHOUT reload
  } else {
    setIsDocUpdating(false);
    handleErrorDailog();
  }
};

  let count = 0;
  return isLoading ? (
    <div className="vendorlistpage">
      <i className="fas fa-spinner fa-pulse fa-2x "></i>
    </div>
  ) : (
    <div className="vendorlistpage">
      <div className="main_section">
      {openDocumentDialog && (
  <div className="document-modal-backdrop">
    <div className="document-modal">
      <h4>Vendor Documents {isDocsVerified && <span style={{ color: "green", fontSize: "14px" }}>✓ Verified</span>}</h4>

      {selectedVendorDocs &&
        Object.keys(selectedVendorDocs).map((key) => (
          <div key={key} style={{ marginBottom: "15px" }}>
            <p><b>{key.replace("_", " ").toUpperCase()}</b></p>
            <img
              src={selectedVendorDocs[key]}
              alt={key}
              style={{ width: "100%", maxHeight: "300px" }}
            />
          </div>
        ))}

      <div style={{ textAlign: "right" }}>
        {!isDocsVerified ? (
          <>
            <button
              className="btn btn-success"
              onClick={() => updateDocumentStatus(true)}
              disabled={isDocUpdating}
            >
              Accept
            </button>

            <button
              className="btn btn-danger"
              style={{ marginLeft: "10px" }}
              onClick={() => updateDocumentStatus(false)}
              disabled={isDocUpdating}
            >
              Decline
            </button>
          </>
        ) : null}

        <button
          className="btn btn-secondary"
          style={{ marginLeft: "10px" }}
          onClick={() => setOpenDocumentDialog(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}

        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={closeConfirmDailog}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des={"Are you sure to delete " + selectedVendorName + " " + "details"}
        ></ConfirmDialogBox>
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={closeAlertDailog}
          title="Added"
          des="New Vendor has been added sccessfully"
        ></AlertDialogBox>
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={closeErrorDailog}
          title="Error"
          des="Someting went wrong. Try again"
        ></ErorrDialogBox>

        <FormPrompt
          openDailog={openFormDailog}
          title="Add New Vendor"
          onSetOpenDailog={closeFormDailog}
          isCloseBtnAppear={isCloseBtnAppear}
        >
          <AddVendor
            setCloseBtnAppear={setCloseBtnAppear}
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={handleErrorDailog}
            collectionName="vendor"
            id="uid"
          ></AddVendor>
        </FormPrompt>

        <div className="topheader">
          <ul>
            <li>
              <i
                className="fa fa-arrow-circle-o-right fa-2x"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              <h5>Vendor</h5>
            </li>
          </ul>
        </div>
        <hr />
        <div className="top_section">
          <div className="wrap">
            <ul>
              <li>
                <div className="search">
                  <input
                    type="text"
                    className="searchTerm"
                    placeholder="Search Vendor by  name"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />

                  <button
                    onClick={handleSearch}
                    type="submit"
                    className="searchButton"
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </li>
              <li style={{ fontSize: "12px" }}> #</li>
              <li style={{ fontSize: "12px" }}>{VendorList.length} </li>
            </ul>
          </div>

          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              setOpenFormDailog(true);
            }}
          >
            + Add Vendor
          </button>
        </div>
        <table className="table table-striped">
          <thead className="thead tablehead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Vendor ID</th>
              <th scope="col">User Image</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Shop Name</th>
              <th scope="col">Shop Address</th>
              <th scope="col">Created Date</th>
              <th>Documents</th>
              <th scope="col">Shop Image</th>
              <th scope="col">Info</th>
              <th scope="col">Flags</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          {isSearching ? (
            <i className="fas fa-spinner fa-pulse fa-2x "></i>
          ) : VendorList.length === 0 ? (
            <tbody>
              <tr>
                <td>No Vendor Found</td>
              </tr>
            </tbody>
          ) : (
            <tbody className="tablebody">
              {VendorList &&
                VendorList.map((p) => {
                  count++;
                  const isPending = !p.documentVerification; // true if the document is not verified yet

                  console.log("VENDOR DATA:", p);
                  console.log("p.uid =", p.uid, "type =", typeof p.uid);
                  // let date = new Date(p.timeStamp.toDate());
                  // const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
                  // const createdDate = `${date.getDate()}/${
                  //   date.getMonth() + 1
                  // }/${date.getFullYear()}`;

                  return (
                    <tr key={p.uid}>
                      <td className="align-middle">{count}</td>
                      <td className="align-middle" style={{ fontSize: "12px", fontWeight: "bold", color: "#007bff" }}>
                        {p.vendorCode || "N/A"}
                      </td>
                      <td className="align-middle">
                        {p.vendorImage === "" ? (
                          <div className="userbg">
                            <i className="fa fa-user fa-2x"></i>
                          </div>
                        ) : (
                          <img
                            className="image"
                            alt=""
                            srcSet={p.vendorImage}
                          />
                        )}
                      </td>
                      <td className="align-middle">{p.name}</td>

                      <td className="align-middle">{p.email}</td>
                      <td className="align-middle">{p.phoneNumber}</td>
                      <td className="align-middle">{p.salonName}</td>
                      <td className="align-middle">{p.salonAddress}</td>
                      <td className="align-middle" style={{ fontSize: "12px" }}>
                        {p.createdAt || "N/A"}
                      </td>
                       {/* ✅ DOCUMENT STATUS */}
                      <td className="align-middle">
  {p.documentVerification === true ? (
    <span 
      style={{ color: "green", fontWeight: "bold", cursor: "pointer" }}
      onClick={() => {
        setSelectedVendorIdd(p.uid);
        setSelectedVendorDocs(p.documents);
        setIsDocsVerified(true);
        setOpenDocumentDialog(true);
      }}
    >
      ✓ Verified
    </span>
  ) : (
    <span
      style={{ color: "orange", cursor: "pointer", fontWeight: "bold" }}
      onClick={() => {
        setSelectedVendorIdd(p.uid);
        setSelectedVendorDocs(p.documents);
        setIsDocsVerified(false);
        setOpenDocumentDialog(true);
      }}
    >
      ⏳ Pending
    </span>
  )}
</td>
                      <td className="align-middle">
                        {p.shopImage === "" ? (
                          <div className="userbg">
                            <i className="fa fa-user fa-2x"></i>
                          </div>
                        ) : (
                          <img className="image" alt="" srcSet={p.shopImage} />
                        )}
                      </td>
                      <td className="align-middle" style={{ fontSize: "12px", minWidth: 120 }}>
                        <div><b>City:</b> {p.city || "—"}</div>
                        <div><b>Type:</b> {p.salonType || "—"}</div>
                        <div><b>Home:</b> {p.homeService ? "✓" : "✗"}</div>
                        <div><b>Doc:</b> {p.documentSubmitted ? "Submitted" : "—"}</div>
                      </td>
                      <td className="align-middle" style={{ minWidth: 160 }}>
                        {[
                          { key: "services", label: "Services" },
                          { key: "stylists", label: "Stylists" },
                          { key: "workDetails", label: "Work Details" },
                          { key: "bankDetails", label: "Bank Details" },
                          { key: "homeService", label: "Home Service" },
                        ].map(({ key, label }) => (
                          <div key={key} style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3 }}>
                            <span style={{ fontSize: "11px", width: 80 }}>{label}</span>
                            <button
                              type="button"
                              className={`btn btn-xs btn-sm ${p[key] ? "btn-success" : "btn-outline-secondary"}`}
                              style={{ padding: "1px 8px", fontSize: "11px" }}
                              onClick={async () => {
                                const res = await Service.updateData({ [key]: !p[key] }, "vendors", p.uid);
                                if (res === "success") onFetchData(limit);
                              }}
                            >
                              {p[key] ? "ON" : "OFF"}
                            </button>
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        <button
                          type="button"
                          className={`btn btn-sm ${p.active ? "btn-success" : "btn-secondary"}`}
                          onClick={() => toggleVendorStatus(p.uid, p.active)}
                          disabled={isTogglingStatus}
                          style={{
                            fontWeight: "bold",
                            minWidth: "100px",
                            padding: "5px 10px",
                          }}
                        >
                          {p.active ? "🟢 Active" : "⚪ Inactive"}
                        </button>
                      </td>

                      <td className="align-middle">
                        <Link to="editvendor">
                          <button
                            onClick={async () => {
                              const sendData = {
                                ...p,
                                collectionName: "vendors",
                                uid: p?.uid,
                              };
                              props.setOnVendorDetails(sendData);
                            }}
                            type="button"
                            className="btn btn-sm btn-success"
                            style={{ marginRight: "5px" }}
                          >
                            <i className="fa fa-edit" aria-hidden="true"></i> Edit
                          </button>
                        </Link>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => {
                            handleOnDelete(p.name, p.uid);
                          }}
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i> Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>

        <div className="loadmoredatasection">
          {isLoadMoreData ? (
            <i className="fas fa-spinner fa-pulse fa-2x loadmoredataspinner"></i>
          ) : (
            <div className="nomoredatatext">{noMoreDataText}</div>
          )}
          {VendorList.length === 0 ? null : isSearchDataShow ? null : (
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => showMore()}
            >
              Show More
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    setOnVendorDetails: (p) => {
      dispatch(setvendor(p));
    },
  };
};

export default connect(null, mapDisptachToProps)(VendorList);
